// This is just an example,
// so you can safely delete all default props below
import strings from './pl-pl.json';
export default strings;
